import PropTypes from "prop-types"
import { EntryModal } from "@ciq/shared/components/modal"

/**
 * Confirmation modal for rolling back zone data.
 *
 * @param {Object} props
 * @param {boolean} props.show - Whether the modal is visible
 * @param {string} props.uploadDate - Formatted date of the upload being rolled back to
 * @param {Function} props.onConfirm - Called when the user confirms the action
 * @param {Function} props.onCancel - Called when the user cancels
 * @param {boolean} [props.isSubmitting] - Whether the action is currently being submitted
 * @returns {React.ReactElement}
 */
export default function ConfirmRollbackModal ({ show, uploadDate, onConfirm, onCancel, isSubmitting }) {
  const actionLabel = isSubmitting ? "Rolling Back..." : "Rollback"

  return (
    <EntryModal
      show={show}
      title="Confirm Rollback"
      onHide={onCancel}
      buttons={{
        secondary: { title: "Cancel", onClick: onCancel, disabled: isSubmitting },
        danger: { title: actionLabel, onClick: onConfirm, disabled: isSubmitting },
      }}
    >
      <p>
        This will rollback zone data to the state from{" "}
        <strong>{uploadDate}</strong>. This cannot be undone.
      </p>
    </EntryModal>
  )
}

ConfirmRollbackModal.propTypes = {
  show: PropTypes.bool.isRequired,
  uploadDate: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
}
